import React from 'react'
import { connect } from 'react-redux'
import { Layout } from 'antd'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import style from './style.module.scss'
import { useAuth0 } from '@auth0/auth0-react'
import { isIframe } from '../../services/utils'

const mapStateToProps = ({ settings }) => ({
  logo: settings.logo,
  isGrayTopbar: settings.isGrayTopbar,
  isCardShadow: settings.isCardShadow,
  isSquaredBorders: settings.isSquaredBorders,
  isBorderless: settings.isBorderless,
  authPagesColor: settings.authPagesColor,
})

const AuthLayout = ({
  children,
  logo,
  isGrayTopbar,
  isCardShadow,
  isSquaredBorders,
  isBorderless,
  authPagesColor,
}) => {
  const { loginWithRedirect } = useAuth0()

  const onSignIn = e => {
    e.preventDefault()
    loginWithRedirect().catch(err => console.error(err))
  }

  return (
    <Layout>
      <Layout.Content>
        <div
          className={classNames(`${style.container}`, {
            cui__layout__squaredBorders: isSquaredBorders,
            cui__layout__cardsShadow: isCardShadow,
            cui__layout__borderless: isBorderless,
            [style.white]: authPagesColor === 'white',
            [style.gray]: authPagesColor === 'gray',
          })}
          style={{
            backgroundImage:
              authPagesColor === 'image' ? 'url(resources/images/content/photos/7.jpg)' : '',
          }}
        >
          {!isIframe() && (
            <div
              className={classNames(`${style.topbar}`, {
                [style.topbarGray]: isGrayTopbar,
              })}
            >
              <div className={style.logoContainer}>
                <div className={style.logo}>
                  <a href="https://www.swifteq.com">
                    <img
                      src="../resources/images/logo.png"
                      className={`mr-2 ${style.logoImage}`}
                      alt="Swifteq"
                    />
                  </a>
                </div>
              </div>
              <div className="d-none d-sm-block">
                <span className="mr-2">Already have an account?</span>
                <a href="#" onClick={onSignIn} className="kit__utils__link font-size-16">
                  Sign in
                </a>
              </div>
            </div>
          )}
          {/*<Sidebar />*/}
          <div className={`${style.containerInner} ${isIframe() ? 'mt-5' : ''}`}>{children}</div>
          {/*<div className="mt-auto pb-5 pt-5">*/}
          {/*  <ul*/}
          {/*    className={`${style.footerNav} list-unstyled d-flex mb-0 flex-wrap justify-content-center`}*/}
          {/*  >*/}
          {/*    <li>*/}
          {/*      <a href="#" onClick={e => e.preventDefault()}>*/}
          {/*        Terms of Use*/}
          {/*      </a>*/}
          {/*    </li>*/}
          {/*    <li>*/}
          {/*      <a href="mailto:support@swifteq.com" onClick={e => e.preventDefault()}>*/}
          {/*        Support*/}
          {/*      </a>*/}
          {/*    </li>*/}
          {/*    <li>*/}
          {/*      <a href="mailto:info@swifteq.com" onClick={e => e.preventDefault()}>*/}
          {/*        Contact us*/}
          {/*      </a>*/}
          {/*    </li>*/}
          {/*  </ul>*/}
          {/*  <div className="text-center">*/}
          {/*    Copyright © 2020 Swifteq |{' '}*/}
          {/*    <a href="https://www.mediatec.org/privacy" target="_blank" rel="noopener noreferrer">*/}
          {/*      Privacy Policy*/}
          {/*    </a>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      </Layout.Content>
    </Layout>
  )
}

export default withRouter(connect(mapStateToProps)(AuthLayout))
